var _g, _g2, _mask, _g3, _path, _path2, _mask2, _g4, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeSimilar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 100,
    viewBox: "0 0 220 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.886 0L151.679 99.5552H175.522L194.491 0H160.886Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.887 0.5L175.108 99.0552H152.228L161.342 0.5H193.887Z",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.617 0H197.356L187.324 41.8975L198.9 99.5552H219.249L208.617 0Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.836 41.9069L197.75 0.5H208.168L218.693 99.0552H199.31L187.836 41.9069Z",
    stroke: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_172:2393",
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 0,
    width: 69,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.886 0L151.679 99.5552H175.522L194.491 0H160.886Z",
    fill: "#A98AD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.617 0H197.356L187.324 41.8975L198.9 99.5552H219.249L208.617 0Z",
    fill: "#A98AD1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.4 -4.40509C154.24 2.47742 165.92 19.5662 165.92 32.8612C165.92 46.1562 147.125 29.9403 137.727 20.1705",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.302 124.224C172.087 97.7931 161.074 63.4334 165.039 50.2181C169.003 37.0028 172.527 92.507 148.74 56.8257",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.446 109.687C206.446 95.5906 207.327 68.8957 210.851 74.8866C215.256 82.3753 217.459 107.925 224.067 109.687",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.193,
    cy: 87.6614,
    r: 3.46459,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.945 71.3625C198.518 62.5523 209.53 61.6713 191.91 83.2563M190.588 -3.0836C188.533 2.49619 183.1 16.0345 177.814 25.5495C171.206 37.4433 171.206 6.60761 180.016 -10.5723",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.064 71.3625C193.084 61.8182 205.037 39.2053 204.684 25.109C204.244 7.48862 189.267 66.0764 220.102 25.109",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20724 0L0 99.5552H23.8429L42.8122 0H9.20724Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9382 0H45.6765L35.6445 41.8975L47.2211 99.5552H67.57L56.9382 0Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_172:2393",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20724 0L0 99.5552H23.8429L42.8122 0H9.20724Z",
    fill: "#A98AD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9382 0H45.6765L35.6445 41.8975L47.2211 99.5552H67.57L56.9382 0Z",
    fill: "#A98AD1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.27874 -4.40509C2.56116 2.47742 14.241 19.5662 14.241 32.8612C14.241 46.1562 -4.55412 29.9403 -13.9517 20.1705",
    stroke: "#9AADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6234 124.224C20.4081 97.7932 9.39534 63.4335 13.3599 50.2182C17.3245 37.0029 20.8486 92.5071 -2.93896 56.8258",
    stroke: "#9AADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7671 109.687C54.7671 95.5907 55.6481 68.8958 59.1722 74.8867C63.5773 82.3754 65.7798 107.925 72.3875 109.687",
    stroke: "#9AADCF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5139,
    cy: 87.6615,
    r: 3.46459,
    stroke: "#9AADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2667 71.3626C46.8389 62.5524 57.8516 61.6714 40.2312 83.2563M38.9097 -3.08354C36.854 2.49625 31.421 16.0346 26.1349 25.5496C19.5273 37.4434 19.527 6.60767 28.3372 -10.5722",
    stroke: "#9AADCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3853 71.3626C41.4056 61.8183 53.358 39.2054 53.0056 25.1091C52.5651 7.48871 37.5878 66.0765 68.4235 25.1091",
    stroke: "#9AADCF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126 51L121 48.1133L121 53.8868L126 51ZM93 51.5L121.5 51.5L121.5 50.5L93 50.5L93 51.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_172:2393",
    x: 147.679,
    y: -4,
    width: 50.812,
    height: 107.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_172:2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_172:2393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_172:2393",
    x: 183.324,
    y: -4,
    width: 39.9253,
    height: 107.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_172:2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_172:2393",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeSimilar);
export default __webpack_public_path__ + "static/media/facade-similar.8f52127a.svg";
export { ForwardRef as ReactComponent };